import React, { memo } from "react";
import AerosNode from "./AerosNode";
import { i18n } from "../../../translate/i18n";

export default memo(({ id, isConnectable, selected }) => (
  <AerosNode
    id={id}
    type="start"
    width={136}
    selected={selected}
    isConnectable={isConnectable}
    hasTarget={false}
    canDuplicate={false}
    canDelete={false}
  >
    {i18n.t("aeros.flow.summary.start")}
  </AerosNode>
));
